module.exports = __webpack_public_path__ + "static/img/1_1_5.1380d873.jpg";